import { fadeIn } from "../../../../scripts/animations";
import { updateFlavorSlider } from "../../../../scripts/pdp/flavorSliderUtils";

import barba from "@barba/core";
import barbaPrefetch from "@barba/prefetch";
import {
  TRANSITION_PRODUCT_VIEW_AFTER,
  TRANSITION_PRODUCT_VIEW_AFTER_ENTER,
  TRANSITION_PRODUCT_VIEW_BEFORE,
  TRANSITION_PRODUCT_VIEW_LEAVE,
} from "./constants";
import { isBarbaLink } from "../../Product/ProductForm/product-form";

/** Barba must only be initialized once: productForm mounts inside the Barba container, so every PDP swap remounts it and would otherwise call init() again (duplicate popstate listeners + broken history stack). */
let productBarbaInitialized = false;

export const useProductView = () => {
  if (document.documentElement.dataset.prefetching === "false") {
    return;
  }
  if (productBarbaInitialized) {
    return;
  }
  productBarbaInitialized = true;

  barba.use(barbaPrefetch);
  barba.init({
    prevent: ({ el }) =>
      !el || el.hasAttribute("data-transition-type") === false,
    views: [
      {
        namespace: "product",
      },
    ],
    transitions: [
      {
        name: "wave-under",
        from: {
          namespace: ["product"],
          custom: ({ trigger }) => {
            if (
              trigger === "back" ||
              trigger === "forward" ||
              trigger === "popstate"
            ) {
              // History navigation must match so Barba swaps HTML; wave is skipped when trigger is not a flavor link (see waveUnder.js).
              return true;
            }
            if (isBarbaLink(trigger)) {
              return (
                trigger.hasAttribute("data-transition-type") &&
                trigger.dataset.transitionType === "wave-under"
              );
            }

            return false;
          },
        },
        sync: true,
        before(data) {
          window.dispatchEvent(
            new CustomEvent(TRANSITION_PRODUCT_VIEW_BEFORE, {
              detail: data,
            })
          );
        },
        enter(data) {
          fadeIn(data.next.container);
        },
        leave(data) {
          window.dispatchEvent(
            new CustomEvent(TRANSITION_PRODUCT_VIEW_LEAVE, {
              detail: data,
            })
          );
        },
        after(data) {
          window.dispatchEvent(
            new CustomEvent(TRANSITION_PRODUCT_VIEW_AFTER, {
              detail: data,
            })
          );

          window.dispatchEvent(
            new CustomEvent("shopify:section:load", {
              detail: data,
            })
          );

          document.dispatchEvent(new Event("recharge:reload"));
          if (window.Rebuy && window.Rebuy.SmartCart) {
            window.Rebuy.SmartCart.bindEvents();
          }

          updateFlavorSlider();
          // Rebuy cart reinitializing after barba transition
          setTimeout(() => {
            try {
              if (window.Rebuy) {
                const cartUpsell = document.querySelector('#rebuy-cart .rebuy-upsell') as HTMLElement | null;
                if (cartUpsell) cartUpsell.innerHTML = '';
                window.Rebuy.reinit();
              }
            } catch (err) {
              console.error("[Rebuy] Failed to reinitialize:", err);
            }
          }, 0);
        },
        afterEnter(data) {
          if (window.innerWidth < 1024) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }

          document.body.classList.add("is-retailer-variant");
          document.body.classList.remove("sticky-cta-bottom");
          window.dispatchEvent(
            new CustomEvent(TRANSITION_PRODUCT_VIEW_AFTER_ENTER, {
              detail: data,
            })
          );
        },
      },
    ],
  });
};
